/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Layout_Drop_HereInputs */

const vi_sidebar_layout_drop_here = /** @type {(inputs: Sidebar_Layout_Drop_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kéo menu con vào đây`)
};

/**

* @param {Sidebar_Layout_Drop_HereInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sidebar_layout_drop_here = /** @type {((inputs?: Sidebar_Layout_Drop_HereInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Layout_Drop_HereInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sidebar_layout_drop_here(inputs)
});